import { Timer } from '@/components/time/countdown-timer';
import { Button } from '@/components/ui/button';
import { useAlertMetrics } from '@/hooks/useAlertMetrics';
import { useShiftControls } from '@/lib/shift/shift-controller';
import { useShiftStore } from '@/lib/shift/shift-store';
import { formatDuration } from '@/lib/time';
import { Apple } from 'lucide-react';

export const OnBreakDialog = () => {
  const controls = useShiftControls();
  const onBreakAt = useShiftStore((s) => s.breakStartedAt);
  const { trackShiftResume } = useAlertMetrics();

  const endBreak = () => {
    controls.endBreak();
    trackShiftResume();
  };

  return (
    <div className="flex-1 bg-green p-8 md:p-24" style={{ height: 'calc(100vh - 56px)' }}>
      <div className="flex h-full items-center justify-center rounded-md border border-muted/30 bg-black/50">
        <div className="flex w-[360px] flex-col gap-y-8">
          <div className="flex gap-x-4">
            <Apple className="mt-1 h-8 w-8" />
            <div>
              <p className="text-lg font-bold">You're currently on break.</p>
              <p className="text-sm opacity-80">
                Resume your shift when you're ready to continue monitoring.
              </p>
            </div>
          </div>
          <div className="flex justify-center rounded-md border border-muted/10 bg-black/20 p-2">
            <p className="font-bold">
              {onBreakAt && <Timer time={onBreakAt} format={(ms) => formatDuration(ms, 'short')} />}
            </p>
          </div>
          <Button onClick={endBreak} className="w-full">
            Resume Shift
          </Button>
        </div>
      </div>
    </div>
  );
};
